var SpmNodeName = {
  OkBtn: {
    key: "OkBtn",
    description: "OK按钮"
  },
  RefreshBtn: {
    key: "RefreshBtn",
    description: "Refresh按钮"
  },
  OpenBtn: {
    key: "OpenBtn",
    description: "OpenBtn按钮"
  },
  DownLoadBtn: {
    key: "DownLoadBtn",
    description: "DownLoad按钮"
  }
};
export default SpmNodeName;
